export enum ExportItemEnum {
  NEW = 'NEW',
  IN_PROGRESS = 'IN_PROGRESS',
  ERROR = 'ERROR',
  DONE = 'DONE',
}
